import {FormFieldValidationResult} from '@mintdata-wsp/common/components/form/Form';
import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {PublishedDesignResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/PublishedDesignResponse';
import {Design, DesignId, IDesignInfo, Project, ProjectId, Template} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DesignsFilter, DesignsFilterType} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsFilters';
import {DesignsSearchFilter} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsSearch';
import {
    DesignsSorting,
    DesignsSortingDirection
} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsSortMenu';
import {TemplatesCategories} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/TemplatesCategorySelector';
import {LocalStateUtil} from '@mintdata-wsp/wsp/util/LocalStateUtil';
import bind from 'bind-decorator';
import {action, computed, runInAction} from 'mobx';
import {match} from 'react-router';

export class MainPageController
{
    @action.bound
    public init():void
    {
        const {
            navigation,
            ui: {artifacts, publishedApps, lx},
            data: {organizations, projects, templates}
        } = controllers;

        // let projectId = null;
        // if( navigation.isOnProjectPage() )
        // {
        //     projectId = navigation.getProjectId();
        // }
        // else
        // {
        //     let orgSid = rootState.userSession.currentOrganization.siteId;
        //     projectId = LocalStateUtil.getSelectedProject(orgSid);
        // }

        // const project = projectId !== null ? rootState.data.projects.find(p => p.id === projectId) : null;

        // if( project )
        // {
        //     this.selectProject(project);
        // }
        // else
        // {
        this.setIsDesignsLoading(true);

        const syncAllProjects = projects.syncAllProjects();
        const publishedAppsInit = publishedApps.init();

        templates.init();

        Promise.all([syncAllProjects, publishedAppsInit]).then(() =>
        {
            this.setIsDesignsLoading(false);
        });

        syncAllProjects.then(() =>
        {
            //             const project = projectId !== null ? rootState.data.projects.find(p => p.id === projectId) : null;
            //             if( project )
            //             {
            //                 this.selectProject(project);
            //             }
            //             else
            //             {
            //                 this.selectFirstProject();
            //             }
            controllers.ui.anyPage.disablePageLoader();
        })
            .catch(err =>
            {
                console.warn(err);
                controllers.ui.anyPage.disablePageLoader();
            });
        // }

        organizations.syncAllOrganizations();

        // artifacts.loadVisualArtifacts().then(() =>
        // {
        //     return artifacts.startLoadingBundlesForVisualArtifacts();
        // });

        controllers.analytics.main.initAllVendors();

        lx.activateLxFrame();

        // TODO: wsp__invite_new_user_first_page_loaded
        controllers.analytics.main.trackEvent(AnalyticsEventActions.WSP_PAGE_LOADED);
    }

    @action.bound
    public selectFirstProject():void
    {
        if( rootState.data.projects.length > 0 )
        {
            this.selectProject(rootState.data.projects[0]);
        }
        else
        {
            controllers.navigation.toAppHome();
        }
    }

    @action.bound
    public selectProject(project:Project):void
    {
        controllers.ui.anyPage.disablePageLoader();

        if( !project ) return;
        rootState.ui.mainPage.currentProject = project;

        const {navigation} = controllers;

        if( navigation.isOnProjectPage() || navigation.isOnHomePage() )
        {
            controllers.navigation.toProject(project.id);
        }

        controllers.ui.mainPage.setCurrentDesignsIfCurrentProject(project, []);
        this.setIsDesignsLoading(true);

        let orgSid = rootState.userSession.currentOrganization.siteId;
        LocalStateUtil.storeSelectedProject(project.id, orgSid);

        controllers.data.designs.getDesignsForProject(project)
            .then((designs:Design[]) =>
            {
                controllers.ui.mainPage.setCurrentDesignsIfCurrentProject(project, designs);

                if( rootState.ui.mainPage.currentProject.id === project.id )
                    this.setIsDesignsLoading(false);
            })
            .catch(err =>
            {
                console.warn(err);
                this.setIsDesignsLoading(false);
            });
    }

    @action.bound
    public setCurrentDesignsIfCurrentProject(project:Project, designs:Design[]):void
    {
        const projectInProjects:Project = controllers.ui.mainPage.getProjectById(project.id);

        if( projectInProjects )
        {
            projectInProjects.designs = designs;
        }

        project.designs = designs;

        if( !rootState.ui.mainPage.currentProject || rootState.ui.mainPage.currentProject.id !== project.id ) return;

        rootState.ui.mainPage.currentProject = project;
        rootState.ui.mainPage.currentDesigns = designs;
    }

    @action.bound
    public setCurrentProject(project:Project):void
    {
        rootState.ui.mainPage.currentProject = project;
    }

    @action.bound
    public setLocationMatch(match:match<any>):void
    {
        rootState.ui.mainPage.locationMatch = match;
    }

    @action.bound
    public setIsDesignsLoading(isDesignsLoading:boolean):void
    {
        rootState.ui.mainPage.isDesignsLoading = isDesignsLoading;
    }

    @action.bound
    public async onCreateAppClicked():Promise<void>
    {
        const {createAppEditor} = rootState.ui.mainPage;

        createAppEditor.isVisible = true;
        createAppEditor.isInitialAppNameGenerating = true;
        createAppEditor.isCreationAppInProgress = false;

        const newDesignName:string = await controllers.data.designs.generateNewDesignName();

        runInAction(() =>
        {
            createAppEditor.initialAppName = newDesignName;
            createAppEditor.isInitialAppNameGenerating = false;
        });
    }

    @action.bound
    public onCancelCreateApplication():void
    {
        const {createAppEditor} = rootState.ui.mainPage;

        createAppEditor.isVisible = false;
        createAppEditor.initialAppName = null;
        createAppEditor.isInitialAppNameGenerating = false;
        createAppEditor.serverError = null;
    }

    public createApplicationInputValidator():FormFieldValidationResult
    {
        const {createAppEditor} = rootState.ui.mainPage;
        const isValid = createAppEditor.serverError === null;
        const errorMessage = isValid ? '' : createAppEditor.serverError;
        return new FormFieldValidationResult(isValid, errorMessage);
    }

    @action.bound
    public onCreateApplicationInputChange():void
    {
        const {createAppEditor} = rootState.ui.mainPage;

        createAppEditor.serverError = null;
    }

    @action.bound
    public toggleHelpCenterVisibility():void
    {
        const {isHelpCenterVisible} = rootState.ui.mainPage;

        rootState.ui.mainPage.isHelpCenterVisible = !isHelpCenterVisible;
    }

    @action.bound
    public onConfirmCreateApplication(newAppName:string):void
    {
        const {createAppEditor, currentProject} = rootState.ui.mainPage;

        createAppEditor.serverError = null;

        if( !newAppName || !newAppName.trim() || !currentProject || createAppEditor.isCreationAppInProgress )
            return;

        createAppEditor.isCreationAppInProgress = true;

        controllers.data.designs.createNewDesign(currentProject, newAppName.trim())
            .then(action((design:Design) =>
            {
                createAppEditor.isVisible = false;
                createAppEditor.isCreationAppInProgress = false;

                const {currentOrganization} = rootState.userSession;

                controllers.analytics.main.trackEvent(
                    AnalyticsEventActions.WSP_DESIGN_CREATED,
                    {
                        org_sid: currentOrganization.siteId,
                        org_name: currentOrganization.name,

                        space_id: currentProject.id,
                        space_name: currentProject.name,

                        design_id: design.id,
                        design_name: design.name
                    }
                );
            }))
            .catch(action((message:string | any) =>
            {
                if( message )
                    createAppEditor.serverError = message;

                createAppEditor.isCreationAppInProgress = false;
            }));
    }

    // ---------------------------------------------------

    @action
    public setMobileMenuVisibility(isVisible:boolean):void
    {
        rootState.ui.mainPage.isMobileMenuVisible = isVisible;
    }

    @action
    public toggleMobileMenuVisibility():void
    {
        const {isMobileMenuVisible} = rootState.ui.mainPage;

        rootState.ui.mainPage.isMobileMenuVisible = !isMobileMenuVisible;
    }

    // ---------------------------------------------------

    public getDesignsFilter(filterType:DesignsFilterType):DesignsFilter
    {
        const {designsFilters} = rootState.ui.mainPage;

        return designsFilters[filterType].filter;
    }

    @action
    public setDesignsFilter(filterType:DesignsFilterType, value:DesignsFilter):void
    {
        const {designsFilters} = rootState.ui.mainPage;

        designsFilters[filterType].filter = value;
    }

    // ---------------------------------------------------

    public getDesignsSorting(filterType:DesignsFilterType):DesignsSorting
    {
        const {designsFilters} = rootState.ui.mainPage;

        return designsFilters[filterType].sorting;
    }

    @action
    public setDesignsSorting(filterType:DesignsFilterType, value:DesignsSorting):void
    {
        const {designsFilters} = rootState.ui.mainPage;

        designsFilters[filterType].sorting = value;
    }

    // ---------------------------------------------------

    public getDesignsSortingDirection(filterType:DesignsFilterType):DesignsSortingDirection
    {
        const {designsFilters} = rootState.ui.mainPage;

        return designsFilters[filterType].direction;
    }

    @action
    public setDesignsSortingDirection(filterType:DesignsFilterType, direction:DesignsSortingDirection):void
    {
        const {designsFilters} = rootState.ui.mainPage;

        designsFilters[filterType].direction = direction;
    }

    // ---------------------------------------------------

    @action
    public setDesignsSearchFilter(filter:DesignsSearchFilter):void
    {
        rootState.ui.mainPage.searchFilter = filter;
    }

    public getDesignsSearchFilter():DesignsSearchFilter
    {
        return rootState.ui.mainPage.searchFilter;
    }

    // ---------------------------------------------------

    @action
    public setDesignsSearchString(string:string):void
    {
        rootState.ui.mainPage.searchString = string;
    }

    public getDesignsSearchString():string
    {
        return rootState.ui.mainPage.searchString;
    }

    // ---------------------------------------------------

    public getProjectById(projectId:ProjectId | number):Project
    {
        return rootState.data.projects.find(({id}) => id == projectId);
    }

    public getPublishedDesignById(id:DesignId | number):PublishedDesignResponse | null
    {
        const {publishedApps} = rootState.data;

        if( !publishedApps ) return null;

        return publishedApps.find(({designId}) => designId == id);
    }

    @computed
    public get allDesigns():Array<IDesignInfo>
    {
        const {projects} = rootState.data;

        const allDesigns:Array<Design> = projects.reduce((all:Design[], prj:Project) => all.concat(prj.designs), []);

        return allDesigns.map((design:Design) =>
        {
            return {
                ...design,
                appInfo: this.getPublishedDesignById(design.id),
            };
        });
    }

    public getDesignById(_id:DesignId | number):IDesignInfo | undefined
    {
        const {allDesigns} = controllers.ui.mainPage;

        return allDesigns.find(({id}) => id == _id);
    }

    // @computed
    // public get allPublishedDesignsIds():Array<DesignId>
    // {
    //     const publishedApps = rootState.ui.publishedApps.list;
    //
    //     if( !publishedApps ) return [];
    //
    //     return publishedApps.map((publishedApp:PublishedDesignResponse) => publishedApp.designId);
    // }

    @computed
    public get allPublishedDesigns():Array<IDesignInfo>
    {
        // const {allPublishedDesignsIds} = controllers.ui.mainPage;

        // if( !allPublishedDesignsIds.length ) return [];

        const {allDesigns} = controllers.ui.mainPage;

        // return allDesigns.filter((design:Design) => allPublishedDesignsIds.indexOf(design.id) !== -1);
        const result:Array<IDesignInfo> = [];

        allDesigns
            .filter(({appInfo}) => appInfo)
            .forEach((design:IDesignInfo) =>
            {
                const {versions} = design.appInfo;

                versions && versions.forEach((version) =>
                {
                    result.push({
                        ...design,
                        appVersion: version
                    });
                });
            });

        return result;
    }

    // ---------------------------------------------------

    @bind
    public getFilteredDesigns(designs:IDesignInfo[] = [], filterType:DesignsFilterType, filter?:DesignsFilter):IDesignInfo[]
    {
        const designsFilter:DesignsFilter = filter || this.getDesignsFilter(filterType);

        if( !designs.length ) return [];

        let _designsForSorting:IDesignInfo[] = [];

        switch( designsFilter )
        {
            case DesignsFilter.All:

                _designsForSorting = designs.slice();
                break;

            case DesignsFilter.Recent:

                return designs.slice().sort((a, b) =>
                {
                    const maxTime1:number = Math.max(a.createdOn || 0, a.modifiedOn || 0, a.accessedOn || 0);
                    const maxTime2:number = Math.max(b.createdOn || 0, b.modifiedOn || 0, b.accessedOn || 0);

                    return maxTime2 - maxTime1;
                });//.slice(0, 10);

            case DesignsFilter.Published:

                switch( filterType )
                {
                    case DesignsFilterType.Applications:

                        const {applicationsSelectedSpaceId} = rootState.ui.mainPage;

                        // designs == allPublishedDesigns
                        if( applicationsSelectedSpaceId )
                            _designsForSorting = designs.filter((design:IDesignInfo) => design.projectId == applicationsSelectedSpaceId);
                        else
                            _designsForSorting = designs.slice();

                        break;

                    default:

                        // const {allPublishedDesignsIds} = controllers.ui.mainPage;

                        // _designsForSorting = designs.filter((design:Design) => allPublishedDesignsIds.indexOf(design.id) !== -1);
                        _designsForSorting = designs.filter(({appInfo}) => appInfo);
                        break;
                }
                break;
        }

        if( filterType == DesignsFilterType.SearchDesigns || filterType == DesignsFilterType.SearchApplications )
        {
            let searchString:string = this.getDesignsSearchString() || '';

            searchString = searchString.trim().toLowerCase();

            if( !searchString ) return [];

            _designsForSorting = _designsForSorting.filter((design:IDesignInfo) =>
                design.name.toLowerCase().indexOf(searchString) !== -1);
        }

        const designsSorting:DesignsSorting = this.getDesignsSorting(filterType);
        const designsSortingDirection:DesignsSortingDirection = this.getDesignsSortingDirection(filterType);

        const direction:number = designsSortingDirection === DesignsSortingDirection.Ascending ? 1 : -1;

        return _designsForSorting.sort((a, b) =>
        {
            let result:number = 0;

            switch( designsSorting )
            {
                case DesignsSorting.LastModified:

                    const aLast = a.modifiedOn || a.accessedOn || a.createdOn || 0;
                    const bLast = b.modifiedOn || b.accessedOn || b.createdOn || 0;

                    result = bLast - aLast;
                    break;

                case DesignsSorting.DateCreated:

                    if( designsFilter === DesignsFilter.Published )
                    {
                        const aTimes:number[] = a.appInfo.versions.map(v => v.publishedAt);
                        const aMaxTime = Math.max.apply(null, aTimes);

                        const bTimes:number[] = b.appInfo.versions.map(v => v.publishedAt);
                        const bMaxTime = Math.max.apply(null, bTimes);

                        result = (bMaxTime || 0) - (aMaxTime || 0);
                    }
                    else
                    {
                        result = (b.createdOn || 0) - (a.createdOn || 0);
                    }

                    break;

                case DesignsSorting.Alphabetically:

                    const aName = a.name.toLowerCase();
                    const bName = b.name.toLowerCase();

                    result = aName.localeCompare(bName);
                    break;
            }

            return result * direction;
            // const orderCmp = b.orderIndex - a.orderIndex;
            // if( orderCmp !== 0 ) return orderCmp;
            // return b.id - a.id;
        });
    }

    // ---------------------------------------------------

    @computed
    public get allTemplates():Array<Template>
    {
        return rootState.data.templates;
    }

    @computed
    public get templatesByCategory():Array<Template>
    {
        const {allTemplates} = controllers.ui.mainPage;

        const {selectedTemplatesCategory} = rootState.ui.mainPage;

        if( selectedTemplatesCategory === TemplatesCategories.All )
            return allTemplates;

        return allTemplates
            .filter(({categories}) => categories && categories.indexOf(selectedTemplatesCategory) !== -1);
    }

    public get getFilteredTemplates():Template[]
    {
        const {templatesByCategory} = controllers.ui.mainPage;

        let searchString:string = this.getDesignsSearchString() || '';

        searchString = searchString.trim().toLowerCase();

        if( !searchString ) return [];

        return templatesByCategory.filter((template:Template) =>
            template.shortTitle.toLowerCase().indexOf(searchString) !== -1);
    }

    public getTemplateByName(templateName:string):Template
    {
        return rootState.data.templates.find(({templateUrl}) => templateUrl === templateName);
    }
}
